/**
 * saveNewUser.js
 * 
 * Saves New User in Firebase Database
 */

import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { Users } from "../../../assets/DatabaseCollections";

/**
 * Saves the new user in the database
 * @param {Object} user     -   Information of the user
 */
export const saveNewUser = async (user) => {
    try {
        const userRef = doc(db, Users, user.uid);
        await setDoc(userRef, {
            displayName     :   user.displayName || '',
            email           :   user.email || '',
            phoneNumber     :   user.phoneNumber || '',
            pfp             :   user.photoURL || '',
            userID          :   user.uid || '',
        })
    } catch (error) {
        console.error('Error in Saving New User : ', error);
    }
}

/**
 * checks if the user exists in the database,
 * if it does, return true, 
 * else return false
 * @param {Object} user     -   Information of the user
 * @returns {Boolean}       -   True, if user exists in the db; false, otherwise
 */
export const checkIfUserExists = async(user) => {
    try {
        const userRef = doc(db, Users, user.uid);

        // --- Fetch the document snapshot ---
        const userSnap = await getDoc(userRef);

        // --- Return existence status ---
        if (userSnap.exists()) {
            return true;
        } else {
            return false;
        }
    } catch (error) { 
        console.error('Error in checking if User exists : ', error);
        return false;
    }
}